import React from 'react';

interface SelectWrapperProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  options: Array<{ value: string; label: string }>;
  id: string;
  className?: string;
}

const SelectWrapper: React.FC<SelectWrapperProps> = ({ 
  label, 
  value, 
  onChange, 
  options, 
  id,
  className = '' 
}) => {
  return (
    <div className={`font-['Geist'] flex flex-col gap-2 w-full sm:w-auto ${className}`}>
      <label 
        htmlFor={id}
        className="text-[#8247E5] text-sm font-medium truncate"
      >
        {label}
      </label>
      <select
        id={id}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="px-4 py-3 sm:py-2 
                  bg-[#30283A] text-white 
                  border border-[#8247E5] rounded 
                  cursor-pointer appearance-none 
                  w-full sm:min-w-[160px] 
                  text-base sm:text-sm
                  hover:border-[#F651AE] focus:border-[#F651AE] 
                  focus:outline-none 
                  transition-colors duration-200"
        style={{
          WebkitAppearance: 'none',
          MozAppearance: 'none',
          backgroundImage: `url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23F651AE' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e")`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'right 8px center',
          backgroundSize: '16px',
          paddingRight: '32px'
        }}
      >
        {options.map((option) => (
          <option 
            key={option.value} 
            value={option.value}
            className="bg-[#30283A] text-white py-2 hover:bg-[#8247E5]/20"
          >
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

interface MarkoutSelectProps {
  selectedMarkout: string;
  onChange: (value: string) => void;
  className?: string;
}

export const MarkoutSelect: React.FC<MarkoutSelectProps> = ({ 
  selectedMarkout, 
  onChange,
  className 
}) => {
  const markoutOptions = [
    { value: 'brontes', label: 'Brontes' },
    { value: '-2.0', label: '-2.0s' },
    { value: '-1.5', label: '-1.5s' },
    { value: '-1.0', label: '-1.0s' },
    { value: '-0.5', label: '-0.5s' },
    { value: '0.0', label: '0s' },
    { value: '0.5', label: '+0.5s' },
    { value: '1.0', label: '+1.0s' },
    { value: '1.5', label: '+1.5s' },
    { value: '2.0', label: '+2.0s' },
  ];

  return (
    <SelectWrapper
      label="Markout Time"
      value={selectedMarkout}
      onChange={onChange}
      options={markoutOptions}
      id="markout-select"
      className={className}
    />
  );
};

interface PoolSelectProps {
  selectedPool: string;
  onChange: (value: string) => void;
  names: Record<string, string>;
  className?: string;
}

export const PoolSelect: React.FC<PoolSelectProps> = ({ 
  selectedPool, 
  onChange, 
  names,
  className 
}) => {
  const poolOptions = Object.entries(names).map(([address, name]) => ({
    value: address,
    label: name,
  }));

  return (
    <SelectWrapper
      label="Uniswap Pool"
      value={selectedPool}
      onChange={onChange}
      options={poolOptions}
      id="pool-select"
      className={className}
    />
  );
};